import AssetService from '@/lib/Asset';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useKeyStats(symbol: string) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['asset', symbol, 'keyStats'],
        queryFn: () => AssetService.getStockOutlook(symbol as string),
        enabled: !!symbol && !!user,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    return query;
}